import { render } from "./purchaseWarehousing.vue?vue&type=template&id=3d95af67&scoped=true&ts=true"
import script from "./purchaseWarehousing.vue?vue&type=script&lang=ts"
export * from "./purchaseWarehousing.vue?vue&type=script&lang=ts"

import "./purchaseWarehousing.vue?vue&type=style&index=0&id=3d95af67&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d95af67"]])

export default __exports__